<div class="dialog">
    <div class="dialog-body">
        <img class="icon-big" src="/assets/img/big-store.svg" alt="Store icon">

        <!-- <h4>{{ 'shared.label.company_number.heading' | translate }}</h4> -->

        <app-loading *ngIf="searching"></app-loading>

        <div class="alert alert-error" *ngIf="error">
            {{ ((error === 404) ? 'stores.list.api.not-found' : 'shared.api.error.down') | translate }}
        </div>

        <form *ngIf="!searching" class="left" [class.ng-submitted]="submitted" #form="ngForm">
            <div class="form-row form-required">
                <label for="">{{ 'shared.label.company_number' | translate }}</label>
                <input #searchInput #company_number="ngModel" type="text" placeholder="{{ 'shared.label.company_number.heading' | translate }}…" name="company_number" pattern="([0-9]{9}|[0-9]{14})" [(ngModel)]="model.company_number">
                <app-form-errors [for]="company_number"></app-form-errors>
            </div>

            <div class="buttons-flex">
                <button class="button button-basic-primary" type="button" (click)="onCancel()">{{ 'shared.button.cancel' | translate }}</button>
                <button class="button button-primary" (click)="onSubmit(form)">{{ 'shared.button.search' | translate }}</button>
            </div>
        </form>
    </div>
</div>

